import React, { ReactNode, useEffect } from "react";
import {
  ThemeProvider as AmplifyThemeProvider,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import amplifyTheme from "../../../amplifyTheme";

interface Props {
  loadApp: () => Promise<void>;
  children: ReactNode;
}

const AmplifyAuth: React.FC<Props> = (props) => {
  const { loadApp, children } = props;

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  useEffect(() => {
    if (authStatus === "authenticated") {
      loadApp();
    } else if (authStatus === "unauthenticated") {
      window.location.href = `${process.env.REACT_APP_AUTH_URL}/app/detector`;
    }
  }, [authStatus, loadApp]);

  return (
    <AmplifyThemeProvider theme={amplifyTheme}>
      {authStatus === "authenticated" ? children : <></>}
    </AmplifyThemeProvider>
  );
};

export default AmplifyAuth;
